import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import "./index.css";

const CheckboxWithDescription = props => {
    const { description, ...pprops } = props;

    return (
        <div>
            <Checkbox {...pprops} />
            {
                description && 
                <p className="checkbox-description">{description}</p>
            }
        </div>
    )
}

export default CheckboxWithDescription;